<template>
  <div class="login-page">
    <div class="login-card">
      <div class="login-header">
        <a href="/">
          <img src="/img/A.png"
            alt="Aktuaalne"
            class="login-logo" />
        </a>
        <h1>Admin Paneel</h1>
      </div>

      <form class="login-form"
        @submit.prevent="submit">
        <Field v-model="username"
          label="Kasutaja"
          icon="fa-regular fa-user"
          autocomplete="username"
          placeholder="kasutaja"
          :disabled="loading" />
        <Field v-model="password"
          label="Parool"
          type="password"
          autocomplete="current-password"
          placeholder="••••••••"
          :disabled="loading" />

        <p v-if="error"
          class="login-error">{{ error }}</p>

        <btn type="submit"
          :disabled="loading || !username || !password">
          <i v-if="loading"
            class="fa-solid fa-spinner fa-spin" />
          Logi sisse
        </btn>
      </form>
    </div>
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/auth'

export default {
  name: 'login',
  data() {
    return {
      username: '',
      password: '',
      error: '',
      loading: false,
    }
  },
  mounted() {
    const auth = useAuthStore()
    if (auth.isLoggedIn) {
      this.$router.replace('/admin')
    }
  },
  methods: {
    async submit() {
      this.error = ''
      this.loading = true
      try {
        const auth = useAuthStore()
        await auth.login(this.username, this.password)
        this.$router.push('/admin')
      } catch (e) {
        if (e.response?.status === 429) {
          this.error = e.response.data
        } else if (e.response?.status === 401) {
          this.error = 'Vale kasutajanimi või parool'
        } else {
          this.error = 'Midagi läks valesti'
        }
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(
    135deg,
    var(--primary-dark) 0%,
    var(--primary) 40%,
    var(--primary-light) 60%,
    var(--primary) 100%
  );
  background-size: 300% 300%;
  animation: gradient-shift 8s ease infinite;
}

@keyframes gradient-shift {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.login-card {
  background: #fff;
  border-radius: 16rem;
  box-shadow: 0 8rem 32rem rgba(0, 0, 0, 0.2);
  padding: 48rem;
  width: 400rem;
  max-width: calc(100vw - 32rem);
}

.login-header {
  text-align: center;
  margin-bottom: 32rem;

  a {
    display: inline-block;
  }

  h1 {
    font-size: 18rem;
    font-weight: 400;
    color: #888;
    margin-top: 12rem;
  }
}

.login-logo {
  height: 60rem;
  display: block;
  margin: 0 auto;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 20rem;
}


.login-error {
  color: #e53e3e;
  font-size: 13rem;
  margin: 0;
}

.login-form .btn {
  justify-content: center;
  margin-top: 4rem;
  padding: 0 24rem;
}
</style>
